import React from 'react';
import PropTypes from 'prop-types';

import {withSettingsContext} from '~/src/components/context/SettingsContext';
import KeyboardListener from '~/src/components/listener/keyboard/KeyboardListener';

import {classNames} from '~/src/utilities/helpers/css';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './CommentModal.module.scss';
import i18nStrings from './CommentModal.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const CommentModal = ({message, onClose, context}) => {
    const {siteArea} = context.settings;
    const className = classNames(css, 'commentModalFullscreen', siteArea);

    return (
        <React.Fragment>
            <div className={className}>
                <div className={css.messageBox}>
                    <div className={css.messageText}>{message}</div>

                    <button className={css.closeButton} onClick={onClose} data-testid="CommentModalClose">
                        {getTranslation('close')}
                    </button>
                </div>

                <KeyboardListener onEsc={onClose} />
                <div className={css.backgroundFilter}></div>
            </div>
        </React.Fragment>
    );
};

if (process.env.NODE_ENV === 'development') {
    CommentModal.propTypes = {
        onClose: PropTypes.func.isRequired,
        message: PropTypes.string.isRequired
    };
}

export default withSettingsContext(CommentModal);
